export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5 2a1 1 0 011 1v3.086l2.793-2.793 1.414 1.414L16.5 8.914v.673c.628.63 1.218 1.25 1.707 1.983.582.872 1.002 1.873 1.274 3.234A1 1 0 0118.5 16H13v7h-2v-7H9.413l-4.707 4.707-1.414-1.414L6.586 16H5.5a1 1 0 01-.98-1.196c.272-1.361.692-2.362 1.273-3.234.49-.733 1.08-1.352 1.707-1.983V3l.005-.103A1 1 0 018.5 2h7zm-4.086 12h5.783a5.825 5.825 0 00-.654-1.32c-.435-.653-.986-1.209-1.75-1.973-.014-.014-.027-.03-.04-.046L11.413 14zM9.5 10a1 1 0 01-.293.707c-.764.764-1.314 1.32-1.75 1.973A5.827 5.827 0 006.804 14h1.782L14.5 8.086V4h-5v6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};